import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// ✅ Renamed usage: this page is now used as "My CV" (authenticated)

import Login from '../pages/Login/Login';
import MainLayout from '../components/Layout/MainLayout';
import ProtectedRoute from '../components/Common/ProtectedRoute';
import RoleHomeRedirect from '../components/Common/RoleHomeRedirect';
import Profile from '../pages/Profile/Profile';

// Dashboards
import AdminDashboard from '../pages/Dashboard/AdminDashboard';
import AdminAnalytics from '../pages/Dashboard/AdminAnalytics';
import AdminMyLeave from '../pages/Dashboard/AdminMyLeave';
import ManagerDashboard from '../pages/Dashboard/ManagerDashboard';
import EmployeeDashboard from '../pages/Dashboard/EmployeeDashboard';

// Vacation Requests
import ManagerVacationRequestsPage from '../pages/VacationRequests/ManagerVacationRequestsPage';
import HrAdminVacationRequestsPage from '../pages/VacationRequests/HrAdminVacationRequestsPage';
import HrAdminAllVacationRequestsPage from '../pages/VacationRequests/HrAdminAllVacationRequestsPage';
import VacationRequestForm from '../pages/VacationRequests/VacationRequestForm';
import NewRequestPage from '../pages/Requests/NewRequestPage';

// User Management
import HrAdminUsers from '../pages/HRAdmin/Users/HrAdminUsers';
import AddUserPage from '../pages/HRAdmin/Users/AddUserPage';
import EmployeeImportPage from '../pages/HRAdmin/Users/EmployeeImportPage';
import EditUserPage from '../pages/HRAdmin/Users/EditUserPage';

// Department Management
import DepartmentList from '../pages/Department/DepartmentList';
import AddDepartmentPage from '../pages/Department/AddDepartmentPage';
import EditDepartmentPage from '../pages/Department/EditDepartmentPage';

// Position Management
import PositionList from '../pages/Position/PositionList';
import AddPositionPage from '../pages/Position/AddPositionPage';
import EditPositionPage from '../pages/Position/EditPositionPage';

// Vacation Balances
import VacationBalanceList from '../pages/VacationBalance/VacationBalanceList';
import AddVacationBalancePage from '../pages/VacationBalance/AddVacationBalancePage';
import EditVacationBalancePage from '../pages/VacationBalance/EditVacationBalancePage';
import VacationBalanceHistoryPage from '../pages/VacationBalance/VacationBalanceHistoryPage';

// Announcements
import AddAnnouncementPage from '../pages/Announcements/AddAnnouncementPage';
import AnnouncementListPage from '../pages/Announcements/AnnouncementListPage';
import EditAnnouncementPage from '../pages/Announcements/EditAnnouncementPage';

// Holidays
import AddHolidayPage from '../pages/Holidays/AddHolidayPage';
import HolidayListPage from '../pages/Holidays/HolidayListPage';
import EditHolidayPage from '../pages/Holidays/EditHolidayPage';

// Exit-Entry
import ExitEntryListPage from '../pages/ExitEntry/ExitEntryListPage';
import ExitEntryFormPage from '../pages/ExitEntry/ExitEntryFormPage';
import ExitEntryEditPage from '../pages/ExitEntry/ExitEntryEditPage';

// Notifications
import NotificationCenterPage from '../pages/Notification/NotificationCenterPage';

// HR Requests (All Requests Page + New/Edit/Detail)
import NewHrRequestForm from '../pages/AllRequests/NewHrRequestForm';
import ShowHrRequestPage from '../pages/AllRequests/ShowHrRequestPage';
import RequestsWithAssignedSplit from '../pages/AllRequests/RequestsWithAssignedSplit';
import EmployeeAllRequestsPage from '../pages/AllRequests/EmployeeAllRequestsPage';

// Assets
import AssetListPage from '../pages/Assets/AssetListPage';
import AddAssetPage from '../pages/Assets/AddAssetPage';
import EditAssetPage from '../pages/Assets/EditAssetPage';
import ShowUserPage from '../pages/HRAdmin/Users/ShowUserPage';

// Attendance
import AttendanceFormPage from '../pages/Attendance/AttendanceFormPage';
import NewAttendancePage from '../pages/Attendance/NewAttendancePage';

// Projects
import ProjectFormPage from '../pages/Project/ProjectFormPage';
import ProjectListPage from '../pages/Project/ProjectListPage';

// Zone Tracking
import ZoneTrackingPage from '../pages/ZoneTracking/ZoneTrackingPage';

// Insurance
import InsurancePolicyList from '../pages/InsurancePolicyList/InsurancePolicyList';
import PrExitEntryPage from '../pages/ExitEntry/PrExitEntryPage';
import ManageAttendance from '../pages/Attendance/ManageAttendance';

// Recruiter / Candidates
import AddCandidateForm from '../pages/Candidate/AddCandidateForm';
import CandidateListPage from '../pages/Candidate/CandidateListPage';
import EditCandidateForm from '../pages/Candidate/EditCandidateForm';
import CandidateDetailPage from '../pages/Candidate/CandidateDetailPage';
import PublicCandidateCvPage from '../pages/Candidate/PublicCandidateCvPage';
import PublicCandidateApplyPage from '../pages/Candidate/PublicCandidateApplyPage';

// Org Chart / Appraisals
import OrgChartPage from '../pages/OrgChart/OrgChartPage';
import AppraisalsList from '../pages/Appraisals/AppraisalsList';
import WorkflowAdmin from '../pages/Performance/WorkflowAdmin';
import ManageAppraisalsPage from '../pages/Performance/Appraisals/ManageAppraisals';
import AppraisalsReportPage from '../pages/Performance/AppraisalsReportPage';

// Performance / My appraisal tasks (current evaluator tasks)
import MyAppraisalTasksPage from '../pages/Performance/MyAppraisalTasksPage';

// Performance / My appraisals (for any role)
import MyAppraisalsPage from '../pages/Performance/MyAppraisalsPage';
import EvaluateAppraisalPage from '../pages/Performance/EvaluateAppraisalPage';
import AppraisalShowPage from '../pages/Performance/AppraisalShowPage';
import SelfReviewAppraisalPage from '../pages/Performance/SelfReviewAppraisalPage';
import AppraisalParticipantsPage from '../pages/Performance/AppraisalParticipantsPage';
import ImportOverallRatingsHistoryPage from '../pages/Performance/ImportOverallRatingsHistoryPage';
import MyEmployeeCvPage from '../pages/cv/MyEmployeeCvPage';
import PublicEmployeeCvPage from '../pages/cv/PublicEmployeeCvPage';
import CvReviewPage from '../pages/cv/CvReviewPage';
import CvShowPage from '../pages/cv/CvShowPage';
import CvEditPage from '../pages/cv/CvEditPage';
import ResetPassword from '../pages/auth/ResetPassword';
import EmailCampaignsListPage from '../pages/Communications/EmailCampaignsListPage';
import EmailCampaignBuilderPage from '../pages/Communications/EmailCampaignBuilderPage';
import EmailCampaignDetailsPage from '../pages/Communications/EmailCampaignDetailsPage';
import MobileNotificationCampaignsListPage from '../pages/Communications/MobileNotificationCampaignsListPage';
import MobileNotificationBuilderPage from '../pages/Communications/MobileNotificationBuilderPage';
import MobileNotificationDetailsPage from '../pages/Communications/MobileNotificationDetailsPage';
import PlatformDashboardPage from '../pages/Platform/PlatformDashboardPage';
import TenantListPage from '../pages/Platform/TenantListPage';
import TenantDetailsPage from '../pages/Platform/TenantDetailsPage';
import TenantFormPage from '../pages/Platform/TenantFormPage';
import TenantLicenseFormPage from '../pages/Platform/TenantLicenseFormPage';
import ReminderAdminPage from '../pages/Platform/ReminderAdminPage';
import RequestWorkflowAdmin from '../pages/Platform/RequestWorkflowAdmin';
import SystemErrorsPage from '../pages/Platform/SystemErrorsPage';
import ApplicationRolesPage from '../pages/Platform/ApplicationRolesPage';
import TenantDataImportPage from '../pages/Platform/TenantDataImportPage';
import {
  EXECUTIVE_ROUTE_ROLES,
  HOD_ROUTE_ROLES,
  OPERATIONS_ROUTE_ROLES,
  PERFORMANCE_ROUTE_ROLES,
  PROFILE_ROUTE_ROLES,
  REQUEST_WORKFLOW_ROUTE_ROLES,
} from '../utils/roleCapabilities';

import JobOffersListPage from '../pages/JobOffers/JobOffersListPage';
import JobOfferForm from '../pages/JobOffers/JobOfferForm';
import JobOfferDetailPage from '../pages/JobOffers/JobOfferDetailPage';

// Pre-Approval (read-only tracking)
import PreApprovalTrackingPage from '../pages/PreApproval/PreApprovalTrackingPage';

// HR Assistant — policy knowledge base
import PoliciesPage from '../pages/Policies/PoliciesPage';
import AssistantTrainingPage from '../pages/Assistant/AssistantTrainingPage';

// Surveys
import SurveyListPage from '../pages/Surveys/SurveyListPage';
import SurveyBuilderPage from '../pages/Surveys/SurveyBuilderPage';
import SurveyResultsPage from '../pages/Surveys/SurveyResultsPage';
import MySurveysPage from '../pages/Surveys/MySurveysPage';
import SurveyRunnerPage from '../pages/Surveys/SurveyRunnerPage';

// Pre-approval authors + approvers (who can meaningfully track them). The HR
// team (hr_team / hr_officer / hr_manager / … — actual_role for most HR staff)
// authors pre-approvals and creates job offers from approved ones, so they get
// the tracking page explicitly rather than relying on incidental role aliasing.
const PRE_APPROVAL_ROUTE_ROLES = Array.from(new Set([
  'hr_admin', 'admin_hr',
  'hr', 'human_resource', 'human_resources',
  'hr_team', 'hr_officer', 'hr_supervisor', 'hr_manager', 'hr_generalist',
  'people_operations', 'people_ops',
  'recruiter', 'talent_acquisition', 'ceo',
  ...HOD_ROUTE_ROLES,
  ...OPERATIONS_ROUTE_ROLES,
  ...EXECUTIVE_ROUTE_ROLES,
]));

const SURVEY_ADMIN_ROLES = ['hr_admin'];
const SURVEY_RESPONDENT_ROLES = [
  'employee', 'manager', 'finance', 'finance_coordinator', 'ceo', 'hr_admin',
  'hr_coordinator', 'recruiter', 'head_of_department', 'operation_manager', 'executive',
];

// Job Offers — HR Admin + HR Team only (no recruiter / talent_acquisition).
const JOB_OFFER_ROUTE_ROLES = [
  'hr_admin', 'admin_hr',
  'hr', 'human_resource', 'human_resources',
  'hr_team', 'hr_officer', 'hr_supervisor', 'hr_manager', 'hr_generalist',
  'people_operations', 'people_ops',
];

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ---------------- Public Routes ---------------- */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/candidate-cv/:token" element={<PublicCandidateCvPage />} />
        <Route path="/candidate-apply" element={<PublicCandidateApplyPage />} />
        <Route path="/public-cv/:token" element={<PublicEmployeeCvPage />} />
        {/* ✅ OLD public token route is disabled now (redirect to login) */}
        <Route
          path="/cv/me2"
          element={
            <ProtectedRoute allowedRoles={PROFILE_ROUTE_ROLES}>
              <MyEmployeeCvPage />
            </ProtectedRoute>
          }
        />

        {/* ---------------- Authenticated Layout ---------------- */}
        <Route element={<MainLayout />}>
          {/* ✅ NEW: My CV (Logged-in, no token) */}
          <Route
            path="/cv/review"
            element={
              <ProtectedRoute
                allowedRoles={['hr_admin', 'recruiter']}
              >
                <CvReviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cv/review/:userId/edit"
            element={
              <ProtectedRoute
                allowedRoles={['hr_admin', 'recruiter']}
              >
                <CvEditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cv/review/:userId"
            element={
              <ProtectedRoute
                allowedRoles={['hr_admin', 'recruiter']}
              >
                <CvShowPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/cv/me"
            element={
              <ProtectedRoute
                allowedRoles={PROFILE_ROUTE_ROLES}
              >
                <MyEmployeeCvPage />
              </ProtectedRoute>
            }
          />

          {/* PERFORMANCE / APPRAISALS */}
          <Route
            path="/performance/appraisals"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ManageAppraisalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance/appraisals/import-excel"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ImportOverallRatingsHistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance/appraisals/report"
            element={
              <ProtectedRoute
                allowedRoles={['ceo', 'finance', 'hr_admin', ...HOD_ROUTE_ROLES, ...OPERATIONS_ROUTE_ROLES, ...EXECUTIVE_ROUTE_ROLES]}
              >
                <AppraisalsReportPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/performance/appraisals/my-tasks"
            element={
              <ProtectedRoute
                allowedRoles={PERFORMANCE_ROUTE_ROLES}
              >
                <MyAppraisalTasksPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/performance/appraisals/my"
            element={
              <ProtectedRoute
                allowedRoles={PERFORMANCE_ROUTE_ROLES}
              >
                <MyAppraisalsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/performance/appraisals/:id/evaluate"
            element={
              <ProtectedRoute
                allowedRoles={PERFORMANCE_ROUTE_ROLES}
              >
                <EvaluateAppraisalPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/performance/appraisals/:id/participants"
            element={
              <ProtectedRoute
                allowedRoles={PERFORMANCE_ROUTE_ROLES}
              >
                <AppraisalParticipantsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance/appraisals/:id/self-review"
            element={
              <ProtectedRoute
                allowedRoles={PERFORMANCE_ROUTE_ROLES}
              >
                <SelfReviewAppraisalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance/appraisals/:id"
            element={
              <ProtectedRoute
                allowedRoles={PERFORMANCE_ROUTE_ROLES}
              >
                <AppraisalShowPage />
              </ProtectedRoute>
            }
          />

          {/* ATTENDANCE */}
          <Route
            path="/admin/attendances/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AttendanceFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/attendances/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AttendanceFormPage isEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendances/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin', 'employee', 'finance_coordinator']}>
                <NewAttendancePage />
              </ProtectedRoute>
            }
          />

          {/* INSURANCE POLICIES */}
          <Route
            path="/admin/insurance-policies"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <InsurancePolicyList />
              </ProtectedRoute>
            }
          />

          {/* ZONE TRACKING */}
          <Route
            path="/admin/zone-tracking"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <Navigate to="/super-admin/zone-tracking" replace />
              </ProtectedRoute>
            }
          />

          {/* PROJECTS */}
          <Route
            path="/admin/projects"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ProjectListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ProjectFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/attendances"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ManageAttendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/appraisal-workflows"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <Navigate to="/super-admin/appraisal-workflows" replace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/email-campaigns"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EmailCampaignsListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/email-campaigns/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EmailCampaignBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/email-campaigns/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EmailCampaignDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/email-campaigns/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EmailCampaignBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/mobile-notifications"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <MobileNotificationCampaignsListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/mobile-notifications/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <MobileNotificationBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/mobile-notifications/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <MobileNotificationDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communications/mobile-notifications/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <MobileNotificationBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <Navigate to="/super-admin/dashboard" replace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/dashboard"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <PlatformDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/tenants"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/tenants/new"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/tenants/:id"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/tenants/:id/edit"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/tenants/:id/licenses/new"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantLicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/tenants/:id/licenses/:licenseId/edit"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantLicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/reminders"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <ReminderAdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/request-workflows"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <RequestWorkflowAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/application-roles"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <ApplicationRolesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/data-import"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantDataImportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/zone-tracking"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <ZoneTrackingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/appraisal-workflows"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <WorkflowAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/platform/errors"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <SystemErrorsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/platform/tenants"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/platform/tenants/new"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/platform/tenants/:id"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/platform/tenants/:id/edit"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/platform/tenants/:id/licenses/new"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantLicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/platform/tenants/:id/licenses/:licenseId/edit"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantLicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/platform/data-import"
            element={
              <ProtectedRoute requirePlatformAdmin>
                <TenantDataImportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ProjectFormPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Dashboards ============ */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/analytics"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AdminAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/my-leave"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AdminMyLeave />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manager/dashboard"
            element={
              <ProtectedRoute allowedRoles={['manager', 'ceo', 'finance', ...HOD_ROUTE_ROLES, ...OPERATIONS_ROUTE_ROLES, ...EXECUTIVE_ROUTE_ROLES]}>
                <ManagerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ceo/dashboard"
            element={
              <ProtectedRoute allowedRoles={['manager', 'ceo', 'finance', ...HOD_ROUTE_ROLES, ...OPERATIONS_ROUTE_ROLES, ...EXECUTIVE_ROUTE_ROLES]}>
                <ManagerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/dashboard"
            element={
              <ProtectedRoute allowedRoles={['employee', 'finance_coordinator', 'recruiter']}>
                <EmployeeDashboard />
              </ProtectedRoute>
            }
          />

          {/* ============ Profile & Notifications ============ */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute
                allowedRoles={PROFILE_ROUTE_ROLES}
              >
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute
                allowedRoles={PROFILE_ROUTE_ROLES}
              >
                <NotificationCenterPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Vacation Requests ============ */}
          <Route
            path="/requests/new"
            element={
              <ProtectedRoute
                allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}
              >
                <NewRequestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vacation-request"
            element={
              <ProtectedRoute
                allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}
              >
                <VacationRequestForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/vacation-requests"
            element={
              <ProtectedRoute allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}>
                <EmployeeAllRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manager/vacation-requests"
            element={
              <ProtectedRoute allowedRoles={['manager', 'ceo', 'finance', ...HOD_ROUTE_ROLES, ...OPERATIONS_ROUTE_ROLES, ...EXECUTIVE_ROUTE_ROLES]}>
                <ManagerVacationRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/vacation-requests"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <HrAdminVacationRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/vacation-requests/all"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <HrAdminAllVacationRequestsPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Assets ============ */}
          <Route
            path="/assets"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AssetListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="assets/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AddAssetPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="assets/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EditAssetPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Pre-Approval (read-only tracking) ============ */}
          <Route
            path="/pre-approvals"
            element={
              <ProtectedRoute allowedRoles={PRE_APPROVAL_ROUTE_ROLES}>
                <PreApprovalTrackingPage />
              </ProtectedRoute>
            }
          />

          {/* ============ HR Requests ============ */}
          <Route
            path="/all-requests"
            element={
              <ProtectedRoute
                allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}
              >
                <RequestsWithAssignedSplit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr-requests/new"
            element={
              <ProtectedRoute
                allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}
              >
                <NewHrRequestForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr-requests/:id/edit"
            element={
              <ProtectedRoute
                allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}
              >
                <NewHrRequestForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr-requests/:id"
            element={
              <ProtectedRoute
                allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}
              >
                <ShowHrRequestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all-requests/:id"
            element={
              <ProtectedRoute
                allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}
              >
                <ShowHrRequestPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Announcements ============ */}
          <Route
            path="/admin/announcements/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AddAnnouncementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/announcements"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AnnouncementListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/announcements/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EditAnnouncementPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Holidays ============ */}
          <Route
            path="/admin/holidays/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AddHolidayPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/holidays"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <HolidayListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/holidays/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EditHolidayPage />
              </ProtectedRoute>
            }
          />

          {/* ============ User Management ============ */}
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <HrAdminUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AddUserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/import"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EmployeeImportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EditUserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ShowUserPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Department Management ============ */}
          <Route
            path="/admin/departments"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <DepartmentList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/departments/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AddDepartmentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/departments/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EditDepartmentPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Position Management ============ */}
          <Route
            path="/admin/positions"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <PositionList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/positions/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AddPositionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/positions/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EditPositionPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Vacation Balances ============ */}
          <Route
            path="/admin/vacation-balances"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <VacationBalanceList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/vacation-balances/new"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AddVacationBalancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/orgchart"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <OrgChartPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/appraisals"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AppraisalsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/vacation-balances/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <EditVacationBalancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/vacation-balances/history"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <VacationBalanceHistoryPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Exit-Entry ============ */}
          <Route
            path="employee/exit-entry/list"
            element={
              <ProtectedRoute allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}>
                <ExitEntryListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exit-entry/list"
            element={
              <ProtectedRoute allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}>
                <ExitEntryListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="employee/exit-entry/pr"
            element={
              <ProtectedRoute allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}>
                <PrExitEntryPage />
              </ProtectedRoute>
            }
          />

          {/* Recruiter / Candidates */}
          <Route
            path="/recruiter/candidates/create"
            element={
              <ProtectedRoute allowedRoles={['hr_admin', 'recruiter', 'employee', 'manager']}>
                <AddCandidateForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/recruiter/candidates"
            element={
              <ProtectedRoute allowedRoles={['hr_admin', 'recruiter', 'employee', 'manager']}>
                <CandidateListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/recruiter/candidates/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['hr_admin', 'recruiter', 'employee', 'manager']}>
                <EditCandidateForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/recruiter/candidates/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin', 'recruiter', 'employee', 'manager']}>
                <CandidateDetailPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/exit-entry/new"
            element={
              <ProtectedRoute allowedRoles={REQUEST_WORKFLOW_ROUTE_ROLES}>
                <ExitEntryFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exit-entry/edit/:id"
            element={
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <ExitEntryEditPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Job Offers (HR Admin + HR Team) ============ */}
          <Route
            path="/hr/job-offers"
            element={
              <ProtectedRoute allowedRoles={JOB_OFFER_ROUTE_ROLES}>
                <JobOffersListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/job-offers/new"
            element={
              <ProtectedRoute allowedRoles={JOB_OFFER_ROUTE_ROLES}>
                <JobOfferForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/job-offers/:id/edit"
            element={
              <ProtectedRoute allowedRoles={JOB_OFFER_ROUTE_ROLES}>
                <JobOfferForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/job-offers/:id"
            element={
              <ProtectedRoute allowedRoles={JOB_OFFER_ROUTE_ROLES}>
                <JobOfferDetailPage />
              </ProtectedRoute>
            }
          />

          {/* ============ Surveys ============ */}
          <Route
            path="/admin/surveys"
            element={(
              <ProtectedRoute allowedRoles={SURVEY_ADMIN_ROLES}>
                <SurveyListPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/admin/surveys/new"
            element={(
              <ProtectedRoute allowedRoles={SURVEY_ADMIN_ROLES}>
                <SurveyBuilderPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/admin/surveys/:id/edit"
            element={(
              <ProtectedRoute allowedRoles={SURVEY_ADMIN_ROLES}>
                <SurveyBuilderPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/admin/surveys/:id/results"
            element={(
              <ProtectedRoute allowedRoles={SURVEY_ADMIN_ROLES}>
                <SurveyResultsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/my/surveys"
            element={(
              <ProtectedRoute allowedRoles={SURVEY_RESPONDENT_ROLES}>
                <MySurveysPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/my/surveys/:id"
            element={(
              <ProtectedRoute allowedRoles={SURVEY_RESPONDENT_ROLES}>
                <SurveyRunnerPage />
              </ProtectedRoute>
            )}
          />

          {/* ============ HR Assistant — Policy Knowledge Base ============ */}
          <Route
            path="/admin/policies"
            element={(
              <ProtectedRoute allowedRoles={['hr_admin', 'hr_coordinator']}>
                <PoliciesPage />
              </ProtectedRoute>
            )}
          />

          {/* ============ HR Assistant — Training (conversations + local answers) ============ */}
          <Route
            path="/admin/assistant-training"
            element={(
              <ProtectedRoute allowedRoles={['hr_admin']}>
                <AssistantTrainingPage />
              </ProtectedRoute>
            )}
          />

          {/* ============ Friendly redirects for common path typos ============ */}
          <Route path="/employee/requests" element={<Navigate to="/employee/vacation-requests" replace />} />
          <Route path="/requests" element={<Navigate to="/requests/new" replace />} />

          {/* ============ Catch-all: role-aware home ============ */}
          <Route path="*" element={<RoleHomeRedirect />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
